import { Component, Input } from "@angular/core";

@Component({
    selector: "spond-header",
    template: require("./spondHeader.component.html").default,
    styles: [require("../../styles/index.scss").default, require("./spondHeader.component.scss").default],
})
export class SpondHeaderComponent {
    @Input()
    assetSpondLogoUrl: any = require("../../../../../spond-web-common-js/src/img/discover/logo_new.svg");

    constructor() {}
}
